import React from 'react';
import { Tooltip, Button } from 'antd';
import TimeSeriesButtons from './TimeSeriesButtons';
import DrawButtons from './DrawButtons';

const LayerToolsRightBar = ({ isButtonClicked, onClick, mapRef }) => {
    return (
        <div className='right-bar'>
            <Tooltip placement='left' title="Identify tool">
                <Button
                    icon={<i className="fa-solid fa-crosshairs" />}
                    onClick={ onClick.marker }
                    className={ isButtonClicked.marker ? "active" : "" } 
                />
            </Tooltip>
             
            <TimeSeriesButtons 
                isButtonClicked={ isButtonClicked }
                onClick={ onClick }
            />

            <Tooltip placement='left' title="Zonal statistics tool">
                <Button
                    onClick={ onClick.zst }
                >
                    <span style={{ fontSize: '1.5em' }}>
                        σ<sup style={{ fontSize: '0.8em' }}>2</sup>
                    </span>
                </Button>
            </Tooltip>
            
            <DrawButtons
                mapRef={ mapRef }
            />
        </div>
    )
}

export default LayerToolsRightBar;